/* eslint-disable react/prop-types */
import './ModulePage.scss';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import {submitSuccessMsg, unsubmitSuccessMsg, publishSuccessMsg} from '../../../constants/messages';

import {
  modulePageReducer,AnimatedEllipsis, SubmitModalConfirmation, UnsubmitModalConfirmation, 
  BasicErrorModal,PublishModalConfirmation,PublishModal,
  Context,BCFP_ROLES_ARR,SUBMITTED_FOR_REVIEW, triggerModal,closeModal,
  SubmitModal,ValidationModal,ADMIN_ROLE
} from './exportfiles';
import Accordion from './Accordion';
import RenderNav from './RenderNav';
import { sorter, determineLastModified, triggerToaster } from '../../../utils/utils';
import { ADMIN, CDS, LOAD, PROFILE, PUBLISHED, SAVE_IN_PROGRESS } from '../../../constants/status';
import { AY } from '../../../constants/reminder';
import { FeatureFlags } from '../../../services/featureflag/featureflags';
import { isFeatureFlagEnable } from '../../../services/featureflag/featureflagservice';
import Button from '../../../components/Button/Button';
import {submitDefaultMsg} from '../../../constants/messages';


const displayDownloadPDFCategories = ['persistenceCategory', 'enrollmentCategory', 'admissionsCategory', 'instFacultyCategory', 'disciplinaryAreasCategory', 'generalInfoCategory', 'academicOfferingsCategory', 'studentLifeCategory', 'annualExpensesCategory', 'financialAidCategory'];

const ModuleContent = ({ CategoryName, org_id, cat_id, status, org_rol_s,
  categTooltip, categoryData, setCategoryStatus,setDisableBar,
  catDispatcher, selApiAttribute}) => {

  let navigate = useNavigate();

  const { getModules, postModule, submitModule, unsubmitModule, validateModule, publishCategory,
    getPriorityCategory, getQuestionTag, putPriorityCategory,putQuestionTag, getReminderDescription, downloadPDF, dispatch, postEvents, state: {reminderData}
  } = React.useContext(Context);
  const [is_BCFP_LIVE, set_BCFP_LIVE] = React.useState('');
  const [showDownloadPdfFlag, setShowDownloadPdfFlag] = React.useState(false);

  //this tableData React.useState is used to populate table
  const [tableData, setTableData] = React.useState([]);
  const [lastModified, setLastModified] = React.useState('');
  const [displayMsg, setDisplayMsg] = React.useState('');
  // const [forceValidate, setForceValidate ] = React.useState(false); // used to trigger inline validation (see SmartDisplay.js)
  // const [disableAutosave, setDisableAutosave] =  React.useState(false);//flag used to disable autosave (see SmartDisplay.js)
  const [publishError, setPublishError] = React.useState();
  const [specialCatEnable, setSpecialCatEnable] = React.useState(true);
  const [isCatLocked, setIsCatLocked] = React.useState(false);
  const [academicYear, setAcademicYear] = React.useState('');
  const DEFAULT_STATE = {
    sampleData: {}, isLoading: false, alertMessage: 'alertMessage',
    unsavedModuleIds: [], triggerModuleId: -1, saveStatus: LOAD
  };

  const [state, dispatcher] = React.useReducer(modulePageReducer, DEFAULT_STATE);
  const { sampleData, isLoading, saveStatus } = state;

  React.useEffect(() => {
    const applicationDataLayer = { page: { pageCode: CategoryName?.replace(/\s/g, "-") } };
    if (typeof kiwi !== 'undefined') kiwi.mergeDdl(applicationDataLayer);
    if (typeof _satellite !== 'undefined') _satellite.track('cbTrack.viewInDom');
  }, [CategoryName]);

  React.useEffect(()=>{
    if(selApiAttribute!==CDS&&selApiAttribute!==PROFILE&&selApiAttribute!==ADMIN){
      const c = categoryData.filter(e=>e.api_attribute===selApiAttribute);
      setIsCatLocked(c[0]?.is_locked === true);
    }
    else{
      setIsCatLocked(categoryData.reduce((acc, curr)=>(acc&&curr.is_locked), true));
    }

  },[categoryData, selApiAttribute]);

  React.useEffect(() => reminderData?.forEach(el => {
    if(el.code===AY) {
      setAcademicYear(`${el.value}`);
    }
  }), [reminderData]);

  const setCatStatus = (catStatus, cid)=>{
    const newcategoryData = categoryData;
    newcategoryData.forEach(el => {
      if (el.id === cid) {
        el.status = catStatus;
      }
    });

    setCategoryStatus(catStatus);
    catDispatcher({ type: "GET_CATEGORY_DATA", payload: newcategoryData });
  };

  const updateModifiedDate = (newdate, cid)=>{
    const newcategoryData = categoryData;
    newcategoryData.forEach(el => {
      if (el.id === cid) {
        el.last_updated_at = newdate;
      }
    });
    catDispatcher({ type: "GET_CATEGORY_DATA", payload: newcategoryData });
  };

  React.useEffect(() => {
    let mounted = true;
    const onLoad = async () => {
      dispatcher({ type: 'SET_LOADING_STATUS', payload: true });

      const resultR = await getReminderDescription();
      dispatch({type: 'UPDATE_REMINDER', payload: resultR.data.data});

      let result, sampleData_temp;
      if (cat_id === PROFILE || cat_id === CDS || cat_id === ADMIN) {
        let results;

        if (cat_id===PROFILE)
          results = await getPriorityCategory(org_id);

        else {
          results = await getQuestionTag(org_id, cat_id);
        }

        if(mounted){
          const res = results.data.data;
          let checkstatus = false;
          result = res.map(elem => (elem.modules).map(el => {
            el.categoryStatus = elem.status;
            if(!checkstatus){
              if(elem.status.toUpperCase()!==PUBLISHED&&(elem.status.toUpperCase()!==SUBMITTED_FOR_REVIEW)){
                checkstatus = true;
              }
            }
            el.isLocked = elem.is_locked;
            el.category_sequence = elem?.sequence;
            el.question_group_sequence = (el?.question_groups[0]) ? sorter(el.question_groups)[0].sequence : el.sequence;
            return el;
          }));
          setSpecialCatEnable(checkstatus);
          const combinedResults = [];
          result.forEach(arr => combinedResults.push(...arr));
          //this sorts each module objects' question_group property 
          combinedResults.forEach(module => sorter(module?.question_groups));
          result = sorter(sorter(sorter(combinedResults, 'question_group_sequence'), 'sequence'), 'category_sequence');
          sampleData_temp = { CategoryName, org_id, modules: [...result] };
        }
      } else {
        if (cat_id) {
          result = await getModules(org_id, `${cat_id}`);
          if(mounted){
            const nonullmodules = result.data?.filter(e => e !== null);
            nonullmodules.forEach(module => sorter(module?.question_groups));
            result.modules = sorter(nonullmodules);
            sampleData_temp = { CategoryName, org_id, ...result };
          }
        }
      }
      if(mounted){
        setLastModified(determineLastModified(sampleData_temp?.modules, categoryData, cat_id));
        dispatcher({ type: 'SET_MODULE_DATA', payload: sampleData_temp });
        dispatcher({ type: 'SET_LOADING_STATUS', payload: false });
        dispatcher({ type: 'SET_SAVE_STATUS', payload: LOAD });
      }
    };
    if(mounted){
      onLoad();
    }
    return () => {
      mounted = false;
      dispatcher({ type: 'SET_SAVE_STATUS', payload: LOAD });
    };
  }, [cat_id]);

  React.useEffect(() => {
    if(lastModified !== '' && sampleData?.modules.length > 0){
      setLastModified(determineLastModified(sampleData?.modules, categoryData, cat_id));
      if(saveStatus !== SAVE_IN_PROGRESS){
        dispatcher({ type: 'SET_SAVE_STATUS', payload: LOAD });
      }
    }
  },[status])

  React.useEffect(() => {
    let mount = true;
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const setflag = async () =>{
      if(mount){
        const displayPdfFlag = await isFeatureFlagEnable(FeatureFlags.displaypdf);
        setShowDownloadPdfFlag(displayPdfFlag);
      }
    };
    setflag();
    return () => {
      mount = false;
    };
  }, []);

  const submitAction = async () => {
    const putdata = [{
      "id": parseInt(cat_id),
      "status": SUBMITTED_FOR_REVIEW
    }];
    try {
      const res = await submitModule(putdata, org_id);
      
      //if error - submitted
      if (res.data.status == 'Error' || res.data.statusCode !== 200 || (res.status !== 200 && res.data === null)) {
        setTableData(res?.data.data);
        triggerModal('submitfailedtrigger');
      } else {
        updateModifiedDate(res.data.data[0].last_updated_at, cat_id);
        setCatStatus(res.data.data[0].status, cat_id);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        triggerToaster(submitSuccessMsg);
        document.getElementById('accordionCol').click();
        setDisableBar(false);
      }
    } catch (error) {
      dispatcher({ type: 'SET_ALERT_MESSAGE', payload: { id: 'errorMessageModal', msg: `Error: ${error.message}, stack trace: ${error.stack}` } });
    }
  };
  // Runs the unsubmit API then verifies
  const unsubmitAction = async () => {
    try {
      //New module connects to unsubmit api (datastore)
      const res = await unsubmitModule(org_id, cat_id);
      //if error then display error
      if (res.data.status === 'Error' || res.data.statusCode !== 200 || (res.status !== 200 && res.data === null)) {
        triggerModal('unsubmiterror');
      } else {
        //do not need to reset display date since we will use last modified module date.
        setCatStatus(res.data.data.status, cat_id);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        triggerToaster(unsubmitSuccessMsg);
        document.getElementById('accordionCol').click();
        setDisableBar(false);
      }
    } catch (error) {
      dispatcher({ type: 'SET_ALERT_MESSAGE', payload: { id: 'errorMessageModal', msg: `Error: ${error.message}, stack trace: ${error.stack}` } });
    }
  };

  const validateAction = async () => {
    try {
      const res = await validateModule(org_id, cat_id);
      if (res.status === 200) {
        //happy path
        if (res.data.data.length === 0) {
          triggerModal('confirmsubmitconfirmation');
        } else {
          //data has mix required and warnings
          setTableData(res?.data.data);
          triggerModal('validationtrigger');
        }
      } else {
        submitAction();
      }
    } catch (error) {
      dispatcher({ type: 'SET_ALERT_MESSAGE', payload: { id: 'errorMessageModal', msg: `Error: ${error.message}, stack trace: ${error.stack}` } });
    }
  };
  // Runs the submit API then verifies
  // Profile, CDS, and Admin Overview
  const submitSpecialCat = async (cat_id)=>{
      try {
        triggerModal('gloader');
        let res = cat_id===PROFILE?await putPriorityCategory(org_id): await putQuestionTag(org_id, cat_id);
        
        closeModal('gloader');
        if (res.data.status == 'Error' || res.data.statusCode !== 200 || (res.status !== 200 && res.data === null)) {
          setTableData(res?.data.data);
          triggerModal('submitfailedtrigger');
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          triggerToaster(submitSuccessMsg);
          document.getElementById('accordionCol').click();
          setDisableBar(false);
        }
      } catch (error) {
        dispatcher({ type: 'SET_ALERT_MESSAGE', payload: { id: 'errorMessageModal', msg: `Error: ${error.message}, stack trace: ${error.stack}` } });
      }
  };

  const onSubmit = async () => {
    setDisableBar(true);
    if(cat_id===CDS || cat_id===PROFILE || cat_id===ADMIN){
      triggerModal('confirmsubmitconfirmation');
    }
    else{
      validateAction();
    }
  };

  const unSubmit = async () => {
    setDisableBar(true);
    triggerModal('confirmunsubmitconfirmation');
  };

  const onPublish = async ()=>{
    setDisableBar(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    triggerModal("publishconfirmation");
  };

  const publish = async()=>{
    try{
      const putdata = [{
        "id":cat_id,
        "status": "PUBLISHED"
      }];

      const res = await publishCategory(putdata, org_id);
      //if error
      if (res.data.status === "Error" || res.data.statusCode !== 200 || (res.status !== 200 && res.data === null)) {
        setPublishError(res?.data.data);
        triggerModal("publisherror");
      } 
      else {
        triggerToaster(publishSuccessMsg);
        updateModifiedDate(res.data.data[0].last_updated_at, cat_id);
        setCatStatus(res.data.data[0].status, cat_id);
        document.getElementById('accordionCol').click();
        setDisableBar(false);
      }
    }catch (err) {
     catDispatcher({type: "ERROR", payload: err});
    }
  };

  const onViewPdfClick = async () => {
    const res = await downloadPDF(org_id, cat_id);
    if(res.data) {
      const file = new Blob([res.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const pdfWindow = window.open();
      pdfWindow.location.href = fileURL; 
    }     
  };

  const showDownloadPDFButton = showDownloadPdfFlag && displayDownloadPDFCategories.includes(selApiAttribute);

  const keynote = ()=> (
  <>
    <span role='image' aria-label='CDSQuestion' className='cb-icon cb-compose cb-black-color' style={{width:'20%', textAlign:'left', padding:'0px 0px 0px 50px'}}>
      <span style={{fontFamily: 'Roboto'}}>&nbsp;CDS Question </span> 
    </span>
  </>);

  // ---REDIRECT WHEN LIVE
  //--'false' means we are not live so BLOCK OUR APP
  if (is_BCFP_LIVE === 'false' && BCFP_ROLES_ARR.includes(org_rol_s)) {
    navigate('/bfcp_is_ready_comingsoon');
  }

  let submitMsg = [];

  if (cat_id !== PROFILE && cat_id !== ADMIN) {
    submitMsg.push(submitDefaultMsg);
  }

  return (
    <div role='region' aria-label={CategoryName}>
      <SubmitModal modalId='submitfailedtrigger' modalData={tableData} />
      <ValidationModal modalId='validationtrigger' modalData={tableData} role={org_rol_s} submitAnywayAction={() => submitAction()} cancelAction={()=>setDisableBar(false)}/>
      <SubmitModalConfirmation submitAction={() => (cat_id===CDS || cat_id===PROFILE || cat_id===ADMIN)?submitSpecialCat(cat_id):submitAction()} 
                               cancelAction={()=>setDisableBar(false)} 
                               modalId='confirmsubmitconfirmation'
                               text={submitMsg}/>


      <UnsubmitModalConfirmation unsubmitAction={() => unsubmitAction()} cancelAction={()=>setDisableBar(false)} modalId='confirmunsubmitconfirmation' />
      <BasicErrorModal modalId='unsubmiterror' unsubmitAction={unSubmit} />
      <PublishModalConfirmation publishAction={()=>publish()} cancelAction={()=>setDisableBar(false)} modalId='publishconfirmation' />
      <PublishModal modalData={publishError} modalId='publisherror' cancelAction={()=>setDisableBar(false)}/>
      <div  className='module-content--area'>
      {isLoading ? <div className='centerEllipsis'><AnimatedEllipsis /></div> : (<>
        {
          showDownloadPDFButton?(<div className='row' style={{display: 'flex', alignItems: 'center'}}>
            {keynote()}
            <div style={{flex: 1, textAlign: 'right', paddingRight: '50px'}}> 
              <Button cb_btn_class='downloadButton' Action={onViewPdfClick} btnText={'Download Survey Answers'} aria-label='Download Survey Answers'  />
            </div> 
            </div>):
          (
            cat_id === CDS &&
            (<div className='row' style={{marginBottom:'50px'}}>
              {keynote()}
            </div>)
          )
        }

        <div className='row' data-testid='module_id' key={`accodion` + cat_id}>
          <Accordion
            categTooltip={categTooltip}
            isLocked={isCatLocked} org_rol_s={org_rol_s} 
            status={status} org_id={org_id} cat_id={cat_id}
            sampleData={sampleData} key_data={cat_id===PROFILE || cat_id === ADMIN} cds={cat_id === CDS} 
            setCatStatus={setCatStatus}
            // forceValidate={{forceValidate, setForceValidate}} disableAutosave={{disableAutosave, setDisableAutosave}}
            dispatcher={dispatcher}
            state={state}
            />
        </div>
      </>)
      }
      </div>
      <div className='cb-sticky cb-sticky-active cb-sticky-bottom row' style={{ "backgroundColor": "#324dc7", 'height': '80px' }}>
        <RenderNav cat_id={cat_id} org_rol_s={org_rol_s} status={status} isLocked={isCatLocked}
          onSubmit={onSubmit} unSubmit={unSubmit} lastModified={lastModified} saveStatus={saveStatus} 
          onPublish={onPublish} enable={org_rol_s===ADMIN_ROLE||specialCatEnable} categoryData={categoryData}/>
      </div>
    </div>
  );
};

export default ModuleContent;